import {
    AFFILIATE_PARTNER_LIST_REQUEST,
    AFFILIATE_PARTNER_LIST_SUCCESS,
    AFFILIATE_PARTNER_LIST_FAIL,
    AFFILIATE_PARTNER_LIST_RESET,
    AFFILIATE_PARTNER_CREATE_REQUEST,
    AFFILIATE_PARTNER_CREATE_SUCCESS,
    AFFILIATE_PARTNER_CREATE_FAIL,
    AFFILIATE_PARTNER_CREATE_RESET,
    AFFILIATE_PARTNER_GET_REQUEST,
    AFFILIATE_PARTNER_GET_SUCCESS,
    AFFILIATE_PARTNER_GET_FAIL,
    AFFILIATE_PARTNER_GET_RESET,
    AFFILIATE_PARTNER_UPDATE_SUCCESS,
    AFFILIATE_PARTNER_UPDATE_REQUEST,
    AFFILIATE_PARTNER_UPDATE_FAIL,
    AFFILIATE_PARTNER_UPDATE_RESET,
    AFFILIATE_PARTNER_DELETE_REQUEST,
    AFFILIATE_PARTNER_DELETE_SUCCESS,
    AFFILIATE_PARTNER_DELETE_FAIL
} from '../constants/affiliatePartnerConstants'

export const affiliatePartnerListReducer = (state = { apartners: [] }, action) => {
    switch (action.type) {
        case AFFILIATE_PARTNER_LIST_REQUEST:
            return { loading: true };
        case AFFILIATE_PARTNER_LIST_SUCCESS:
            return { loading: false, apartners: action.payload }
        case AFFILIATE_PARTNER_LIST_FAIL:
            return { loading: false, error: action.payload }
        case AFFILIATE_PARTNER_LIST_RESET:
            return { loading: false, apartners: [] }
        default:
            return state;
    }
}

export const affiliatePartnerCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case AFFILIATE_PARTNER_CREATE_REQUEST:
            return { loading: true };
        case AFFILIATE_PARTNER_CREATE_SUCCESS:
            return { loading: false, success: action.payload }
        case AFFILIATE_PARTNER_CREATE_FAIL:
            return { loading: false, error: action.payload }
        case AFFILIATE_PARTNER_CREATE_RESET:
            return { loading: false, success: '' }
        default:
            return state;
    }
}

export const affiliatePartnerDetailsReducer = (state = { apartner: [] }, action) => {
    switch (action.type) {
        case AFFILIATE_PARTNER_GET_REQUEST:
            return { loading: true, apartner: [] };
        case AFFILIATE_PARTNER_GET_SUCCESS:
            return { loading: false, apartner: action.payload }
        case AFFILIATE_PARTNER_GET_FAIL:
            return { loading: false, error: action.payload }
        case AFFILIATE_PARTNER_GET_RESET:
            return { loading: false, apartner: [] }
        default:
            return state;
    }
}

export const affiliatePartnerUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case AFFILIATE_PARTNER_UPDATE_REQUEST:
            return { loading: true };
        case AFFILIATE_PARTNER_UPDATE_SUCCESS:
            return { loading: false, success: action.payload }
        case AFFILIATE_PARTNER_UPDATE_FAIL:
            return { loading: false, error: action.payload }
        case AFFILIATE_PARTNER_UPDATE_RESET:
            return { loading: false, success: '' }
        default:
            return state;
    }
}

export const affiliatePartnerDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case AFFILIATE_PARTNER_DELETE_REQUEST:
            return { loading: true };
        case AFFILIATE_PARTNER_DELETE_SUCCESS:
            return { loading: false, success: action.payload }
        case AFFILIATE_PARTNER_DELETE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

